import { useEffect, useState } from 'react';
import axios from 'axios';

const SuccessPage = () => {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      const sessionId = new URLSearchParams(window.location.search).get('session_id');
      if (sessionId) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/orders/session/${sessionId}`
          );
          setOrder(response.data);
        } catch (error) {
          console.error('Error fetching order details:', error);
        }
      }
    };

    fetchOrderDetails();
  }, []);

  return (
    <div>
      <h1>Payment Successful!</h1>
      {order ? (
        <div>
          <p>Order ID: {order.orderId}</p>
          <p>Price: ${order.priceInUSD}</p>
          <p>Currency: {order.currency}</p>
        </div>
      ) : (
        <p>Loading order details...</p>
      )}
    </div>
  );
};

export default SuccessPage;
